import { createContext, ReactNode, useMemo } from "react";
import { useTranslation } from "react-i18next";
import ru from "../../../public/locales/ru/translation.json";

type initState = {
  project: typeof ru["portfolio"][0];
};

const projectContext = createContext({} as initState);

type ProviderProps = {
  children: ReactNode;
  projectId: string;
};

export const ProjectContextProvider = (props: ProviderProps) => {
  const { projectId, children } = props;
  const { t } = useTranslation();
  const projects = t("portfolio", { returnObjects: true });

  const project = useMemo(() => {
    const project = projects.find((project) => project.id === projectId);
    return project!;
  }, [projects, projectId]);

  return <projectContext.Provider value={{ project }}>{children}</projectContext.Provider>;
};

export default projectContext;
